import { defineStore } from "pinia";
import { updateThumbnailPath } from "@shared/functions";

export const useImageStore = defineStore('image', {
  state: () => {
    return {
      images: []
    }
  },

  getters: {
    hasImages(state) {
      return () => state.images.length > 0;
    }
  },

  actions: {
    set(imagesToSet) {
      this.images = [...imagesToSet.map(updateThumbnailPath)];
    },

    append(imagesToAppend) {
      this.images = [...this.images, ...imagesToAppend.map(updateThumbnailPath)];
    },

    clear() {
      this.images = [];
    }
  }
})